module.exports = __webpack_public_path__ + "static/media/rectangle.53cb2835.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/form/Type/rectangle.svg
 ** module id = 195
 ** module chunks = 0
 **/